import { render } from "./Manufacturer.vue?vue&type=template&id=6d1d3e6c&scoped=true"
import script from "./Manufacturer.vue?vue&type=script&lang=js"
export * from "./Manufacturer.vue?vue&type=script&lang=js"

import "./Manufacturer.vue?vue&type=style&index=0&id=6d1d3e6c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1d3e6c"]])

export default __exports__